import styled from "styled-components";

export const TextAreaFromJsonContainer = styled("div").withConfig({
   shouldForwardProp: p => !["isLastElement"].includes(p)
})<{ isLastElement?: boolean }>`
   width: 100%;
   margin-top: 30px;
`;
